export const convertToBase64 = async (imageFile, callback) => {
  if (!imageFile) return;
  try {
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64data = reader.result;
      callback({
        name: imageFile.name,
        base64: base64data,
      });
    };
    reader.readAsDataURL(imageFile);
  } catch (error) {
    console.log(error);
  }
};